<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/gtGcXS/tc-custom/9781466850224.jpg?1726889940278" alt="This image is the cover for the book Carpet Makers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Carpet Makers
      </h1>
      <p class="bookDescription body article font2">
        <b>“Enthusiastically introduced by no less than Orson Scott Card, this far-future novel does credit to everyone concerned, starting with its German author.” —<i>Booklist</i></b><br/><br/>Since the time of pre-history, carpetmakers tie intricate knots to form carpets for the court of the Emperor. These carpets are made from the hairs of wives and daughters; they are so detailed and fragile that each carpetmaker finishes only one single carpet in his entire lifetime.<br/><br/>This art descends from father to son, since the beginning of time itself.<br/><br/>But one day the empire of the God Emperor vanishes, and strangers begin to arrive from the stars to follow the trace of the hair carpets. What these strangers discover is beyond all belief, more than anything they could have ever imagined . . .<br/><br/>Brought to the attention of Tor Books by Orson Scott Card, this edition of <i>The Carpet Makers </i>contains his special introduction.<br/><br/><b>“Eschbach’s first novel will blow you away. Yes, it’s that good.” —<i>Analog</i></b><br/><br/><b>“A considerable achievement, and one that suggests the presence of a world-class SF voice that we ought to know about.” —<i>Locus</i></b><br/><br/><b>“Andreas Eschbach is incontestably the shooting star of the German SF scene.” —<i>Heyne Science Fiction Yearbook</i></b><br/><br/><b>“That such a magnum opus has been allowed to languish in the shadows for ten years is damning evidence of how parochial SF publishing can be. Even more astounding, it was Eschbach’s debut.” —<i>Kirkus Reviews</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Andreas Eschbach, Orson Scott Card
      </h2>
      
      <p class="authorDescription body article"><P><B><I>Andreas Eschbach </I></B>was born 1959 in Ulm, Germany.  In 1996, his first novel, <I> Die </I><I>Haarteppichknüpfer</I> (<I>The Hair Carpet Makers</I>),  won one of the highest awards of German science fiction, the SFCD-Literaturpreis. His second novel, <I>Solarstation</I>, won the other great German science fiction award, the Kurd Laßwitz Preis. His third novel, <I>Jesus Video</I>, won both of them, became a nationwide bestseller in 2000, and was turned into a movie in 2002. <br><br>His first translation into another language was in 1998, when <I>Die </I><I>Haarteppichknüpfer</I> was published in France as <I>Des milliards des tapis de cheveux</I>. It was not only the first German science fiction novel to be published in France after 18 years, it also won two literary prizes in France and Belgium. Several novels and short stories have been translated since then, into French, Italian, Czech, Japanese, Russian, and Turkish.<br><br>Eschbach currently lives in Stuttgart with his family.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      A Tom Doherty Associates Book
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1000a6e6